import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4635ad7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row securities_basic w-100 m-0" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Investment Amount ", -1))
const _hoisted_6 = { class: "m-0 p-0 myinv_label_white" }
const _hoisted_7 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Date Invested ", -1))
const _hoisted_9 = { class: "m-0 p-0 myinv_label_white" }
const _hoisted_10 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Investment Valuation ", -1))
const _hoisted_12 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_13 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Total Principle Paid ", -1))
const _hoisted_15 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_16 = { class: "row mt-2" }
const _hoisted_17 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Investment Duration ", -1))
const _hoisted_19 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_20 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Dividends Next Paid ", -1))
const _hoisted_22 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_23 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Current Principle ", -1))
const _hoisted_25 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_26 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Currency ", -1))
const _hoisted_28 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_29 = { class: "row mt-2" }
const _hoisted_30 = {
  class: "col-md-2 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Growth ", -1))
const _hoisted_32 = { class: "m-0 p-0 myinv_label_white" }
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-1 p-0\" style=\"border:1px solid #ececec87;\" data-v-4635ad7d><p class=\"m-0 p-0 myinv_label_main\" data-v-4635ad7d> ROI </p><p class=\"m-0 p-0 myinv_label_white\" data-v-4635ad7d> - </p></div><div class=\"col-md-1 p-0\" style=\"border:1px solid #ececec87;\" data-v-4635ad7d><p class=\"m-0 p-0 myinv_label_main\" data-v-4635ad7d> IRR </p><p class=\"m-0 p-0 myinv_label_white\" data-v-4635ad7d> - </p></div>", 2)
const _hoisted_35 = {
  class: "col-md-1 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Yield ", -1))
const _hoisted_37 = { class: "m-0 p-0 myinv_label_white" }
const _hoisted_38 = {
  class: "col-md-2 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Return ", -1))
const _hoisted_40 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_41 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Issue Price ", -1))
const _hoisted_43 = { class: "m-0 p-0 myinv_label_white" }
const _hoisted_44 = {
  class: "col-md-2 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Number of Notes ", -1))
const _hoisted_46 = { class: "m-0 p-0 myinv_label_white" }
const _hoisted_47 = { class: "row mt-2" }
const _hoisted_48 = {
  class: "col-md-2 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Rank ", -1))
const _hoisted_50 = { class: "m-0 p-0 myinv_label_white" }
const _hoisted_51 = {
  class: "col-md-2 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Type ", -1))
const _hoisted_53 = { class: "m-0 p-0 myinv_label_white" }
const _hoisted_54 = {
  class: "col-md-2 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Investment Period ", -1))
const _hoisted_56 = { class: "m-0 p-0 myinv_label_white" }
const _hoisted_57 = {
  class: "col-md-1 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Coupon ", -1))
const _hoisted_59 = { class: "m-0 p-0 myinv_label_white" }
const _hoisted_60 = {
  class: "col-md-2 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Subscription ", -1))
const _hoisted_62 = { class: "m-0 p-0 myinv_label_white" }
const _hoisted_63 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Receipt ", -1))
const _hoisted_65 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_66 = { class: "row mt-2" }
const _hoisted_67 = {
  class: "col-md-2 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Asset Type ", -1))
const _hoisted_69 = { class: "m-0 p-0 myinv_label_white" }
const _hoisted_70 = {
  class: "col-md-2 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Asset Sector ", -1))
const _hoisted_72 = { class: "m-0 p-0 myinv_label_white" }
const _hoisted_73 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Location ", -1))
const _hoisted_75 = { class: "m-0 p-0 myinv_label_white" }
const _hoisted_76 = {
  class: "col-md-2 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Merchant Fees ", -1))
const _hoisted_78 = { class: "m-0 p-0 myinv_label_white" }
const _hoisted_79 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Maturity Dates ", -1))
const _hoisted_81 = { class: "m-0 p-0 myinv_label_semi_white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.basic.investment_amount), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.basic.date_invested), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.basic.investment_valuation), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.basic.principle_paid), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.basic.investment_duration), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.basic.dividend_next_paid), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.basic.dividend_next_paid), 1)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.basic.currency_name), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.basic.growth), 1)
        ]),
        _hoisted_33,
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.basic.yield), 1)
        ]),
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.basic.return), 1)
        ]),
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.basic.issue_price), 1)
        ]),
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.basic.no_of_notes), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.basic.rank), 1)
        ]),
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.basic.type), 1)
        ]),
        _createElementVNode("div", _hoisted_54, [
          _hoisted_55,
          _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.basic.investment_period), 1)
        ]),
        _createElementVNode("div", _hoisted_57, [
          _hoisted_58,
          _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.basic.coupon), 1)
        ]),
        _createElementVNode("div", _hoisted_60, [
          _hoisted_61,
          _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.basic.subscription), 1)
        ]),
        _createElementVNode("div", _hoisted_63, [
          _hoisted_64,
          _createElementVNode("p", _hoisted_65, _toDisplayString(_ctx.basic.receipt), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_66, [
        _createElementVNode("div", _hoisted_67, [
          _hoisted_68,
          _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.basic.asset_type), 1)
        ]),
        _createElementVNode("div", _hoisted_70, [
          _hoisted_71,
          _createElementVNode("p", _hoisted_72, _toDisplayString(_ctx.basic.asset_sector), 1)
        ]),
        _createElementVNode("div", _hoisted_73, [
          _hoisted_74,
          _createElementVNode("p", _hoisted_75, _toDisplayString(_ctx.basic.location), 1)
        ]),
        _createElementVNode("div", _hoisted_76, [
          _hoisted_77,
          _createElementVNode("p", _hoisted_78, _toDisplayString(_ctx.basic.merchant_fees) + " % ", 1)
        ]),
        _createElementVNode("div", _hoisted_79, [
          _hoisted_80,
          _createElementVNode("p", _hoisted_81, _toDisplayString(_ctx.basic.maturity_date), 1)
        ])
      ])
    ])
  ]))
}